import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const CTABanner = () => {
  const { t } = useLanguage();
  return <section className="py-16 bg-crystal-blue text-white"><div className="container-custom px-4 flex justify-between items-center"><h2 className="text-2xl font-bold">Ready for Your New Smile?</h2><Link to="/contact" className="btn-accent">{t('nav.bookNow')}</Link></div></section>;
};

export default CTABanner;
